import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { Row } from '@global-engineering-shared/gweb-material-types';
import { useNavigate } from 'react-router';

import { ITableConfig } from 'components/Table/types/table';
import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import ExportButton from 'features/Drafts/components/ExportButton';
import RemoveButton from 'features/Drafts/components/RemoveButton';
import SyncButton from 'features/Drafts/components/SyncButton';
import useDraftsTableColumns from 'features/Drafts/utils/useDraftsTableColumns';
import { TTableEntity } from 'types/tableEntityType';
import {
  DEFAULT_TABLE_GRID_TEMPLATE,
  DRAFTS_ERROR_API_URL,
  DRAFTS_PAGE_URL,
  DRAFTS_READY_API_URL,
  DRAFTS_SYNCING_API_URL,
} from 'utils/defaults';
import { DraftStatus, DraftStatusByTable } from 'utils/statuses';

const INCLUDE_CHECKBOX = true;
const EXCLUDE_CHECKBOX = false;

export const useDraftsTables = (): ITableConfig[] => {
  const navigate = useNavigate();
  const { refreshToggle } = useRefresh();

  return [
    {
      isCollapsable: true,
      hasCheckboxes: false,
      collapsableTitle: 'Drafts',
      tableTitle: 'Syncing',
      keyName: 'spaceId',
      columns: useDraftsTableColumns(EXCLUDE_CHECKBOX),
      url: DRAFTS_SYNCING_API_URL,
      tableItemGridTemplate: DEFAULT_TABLE_GRID_TEMPLATE,
      statusBorderColor: theme.palette.primary.main,
      handleRowClick: (row: Row<TTableEntity>) =>
        navigate(`${DRAFTS_PAGE_URL}/${row.original.spaceId}`),
      refreshToggle,
    },
    {
      isCollapsable: true,
      hasCheckboxes: true,
      collapsableTitle: 'Drafts',
      tableTitle: 'Ready',
      keyName: 'spaceId',
      columns: useDraftsTableColumns(INCLUDE_CHECKBOX),
      url: DRAFTS_READY_API_URL,
      secondaryFooterComponents: [
        <RemoveButton status={DraftStatusByTable.READY} />,
        <ExportButton status={DraftStatusByTable.READY} />,
        <SyncButton />,
      ],
      tableItemGridTemplate: DEFAULT_TABLE_GRID_TEMPLATE,
      statusBorderColor: theme.palette.success.main,
      handleRowClick: (row: Row<TTableEntity>) =>
        navigate(`${DRAFTS_PAGE_URL}/${row.original.spaceId}`),
      refreshToggle,
    },
    {
      isCollapsable: true,
      hasCheckboxes: true,
      collapsableTitle: 'Drafts',
      tableTitle: 'Error',
      keyName: 'spaceId',
      columns: useDraftsTableColumns(INCLUDE_CHECKBOX),
      url: DRAFTS_ERROR_API_URL,
      secondaryFooterComponents: [
        <RemoveButton status={DraftStatusByTable.ERROR} />,
        <ExportButton status={DraftStatusByTable.ERROR} />,
      ],
      tableItemGridTemplate: DEFAULT_TABLE_GRID_TEMPLATE,
      statusBorderColor: theme.palette.error.main,
      handleRowClick: (row: Row<TTableEntity>) => {
        if (row.original.status != DraftStatus.NOT_FOUND) {
          navigate(`${DRAFTS_PAGE_URL}/${row.original.spaceId}`);
        }
      },
      refreshToggle,
    },
  ];
};
